import locale from "csi/locale";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import String from "csi/heading/String";
import TextWithMaterialIcon from "csi/widget/TextWithMaterialIcon";
import declare from "dojo/_base/declare";

const roles = {
	Viewer: "ProofTaskViewer",
	Reviewer: "ProofTaskReviewer",
	Approver: "ProofTaskApprover",
};

const ProofAccessRenderer = declare(String, {
	/**
	 * @override
	 * Render user Proof Task access role
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: Element, _params) {
		const value = this._getValue(ctx, h);
		const text = locale.resource(roles[value]);

		new TextWithMaterialIcon({
			text: text,
		})
			.placeAt(refNode);
		return true;
	},
});

export = ProofAccessRenderer;